export default __webpack_public_path__ + "static/media/pantry1-afterE-1920w.e0128853.png";